import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button, Input, CardBody } from "reactstrap";
import { Filter, DefaultColumnFilter } from "./filters";
import JobListGlobalFilter from "../../components/Common/GlobalSearchFilter";
import { post } from '../../helpers/api_helper'
// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <React.Fragment>
      <Col md={4}>
        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`${count} records...`}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>

      </Col>
      {isJobListGlobalFilter && (
        <JobListGlobalFilter />
      )}

    </React.Fragment>
  );
}

const TableContainer = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  className,
  customPageSizeOptions,
  totalCount,
  handlePageNav,
  handlePageSizeChange,
  currentPage,
  shouldIncludeNotStarted,
  includeNotStarted,
  handleSort,
  sortBy,
  sortOrder

}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      // initialState: {
      //   pageIndex: 0,
      //   pageSize: customPageSize,
      //   sortBy: [
      //     {
      //       desc: true,
      //     },
      //   ],
      // },
      initialState: { pageIndex: 0, pageSize: customPageSize || 10 }, // Set the initial page size
      manualPagination: true, // Enable manual pagination
      pageCount: Math.ceil(totalCount / (customPageSize || 10)),
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const [newLink, setNewLink] = useState('')
  const generateSortingIndicator = column => {
    // For status column, use custom sorting state
    if (column.id === 'status' && handleSort) {
      if (sortBy === 'status') {
        return sortOrder === 'desc' ? " 🔽" : " 🔼";
      }
      return "";
    }
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };
  return (
    <Fragment>
      <Row className="mb-2">
        <Col md={customPageSizeOptions ? 2 : 1}>
          {/* <select
            className="form-select"
            value={pageSize}
            onChange={onChangeInSelect}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select> */}
        </Col>
        {/* {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isJobListGlobalFilter={isJobListGlobalFilter}
          />
        )} */}
        {isAddOptions && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded  mb-2 me-2"
                onClick={handleOrderClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add New Order
              </Button>
            </div>
          </Col>
        )}

        <Col sm="12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i 
              className={`mdi ${includeNotStarted ? 'mdi-eye-outline' : 'mdi-eye-off-outline'}`}
              style={{ 
                fontSize: '16px', 
                color: includeNotStarted ? '#28a745' : '#dc3545' 
              }}
            ></i>
            <span style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#6c757d'
            }}>
              {includeNotStarted ? 'Showing' : 'Hiding'} Not Started
            </span>
            <Button 
              color={includeNotStarted ? 'success' : 'danger'}
              size="sm"
              onClick={() => {
                shouldIncludeNotStarted();
              }}
              style={{
                borderRadius: '4px',
                padding: '4px 12px',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {includeNotStarted ? 'Hide' : 'Show'}
            </Button>
          </div>
          {isAddUserList && (<div className="text-sm-end">
            <Button
              type="button"
              color="primary"
              className="btn mb-2 me-2"
              onClick={async () => {
                const a = await post(process.env.REACT_APP_API_URL + '/users')
                setNewLink(process.env.REACT_APP_UI_URL + '/' + a.uid)
                handleUserClick(process.env.REACT_APP_UI_URL + '/' + a.uid)
              }}
            >
              <i className="mdi mdi-plus-circle-outline me-1" />
              New Applicant
            </Button>
          </div>)}
        </Col>

        {isAddCustList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClick}
              >
                <i className="mdi mdi-plus me-1" />
                New Customers
              </Button>
            </div>
          </Col>
        )}
      </Row>

      <div className="table-responsive react-table">
        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th key={column.id} {...column.getHeaderProps(column.getSortByToggleProps())}>
                    <div className="mb-0">
                      <span 
                        style={{ cursor: column.canSort ? 'pointer' : 'default' }}
                        onClick={() => {
                          if (column.canSort && column.id === 'status' && handleSort) {
                            // Use custom sorting for status column
                            handleSort(column.id);
                          }
                        }}
                      >
                        {column.render("Header")}
                        {generateSortingIndicator(column)}
                      </span>
                      <Filter column={column} />
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row);
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map(cell => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => handlePageNav('first')}
              disabled={currentPage === 1}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              // onClick={previousPage}
              // disabled={!canPreviousPage}
              onClick={() => handlePageNav('prev')} disabled={currentPage === 1}
            >
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>
            {pageCount === 0 ? 0 : currentPage} of {pageCount}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={pageCount}
            defaultValue={currentPage}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button color="primary" onClick={() => handlePageNav('next')} disabled={currentPage >= Math.ceil(totalCount / pageSize)}>
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => handlePageNav('last')}
              disabled={currentPage >= Math.ceil(totalCount / pageSize)}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
